import request from './request'

function getActivityBanners(data) {
    return request('get','/qxapi/edu/activitybanner/activitybanners', data)
}

function list(data) {
    return request('get','/qxapi/edu/activitysetting/page', data)
}

function getById(data) {
    return request('get','/qxapi/edu/activitysetting/get_details/' + data)
}

function getActivitys(data) {
    return request('get','/qxapi/edu/activity/activitys', data)
}

function getActivityById(data) {
    return request('get','/qxapi/edu/activity/activitys/'+ data)
}

function getActivityDetails(data) {
    return request('get','/qxapi/edu/activity/activitydetails/'+ data)
}

function buyActivity(data) {
    return request("post", "/qxapi/edu/activity/buyactivity", data)
}

function checkActivityAage(data) {
    return request("get", "/qxapi/edu/activity/checkactivityage", data)
}

function checkField(data) {
    return request("post", "/qxapi/edu/activity/checkfield", data)
}

export default {
    list,
	getById,
    getActivitys,
    getActivityById,
    getActivityDetails,
    buyActivity,
    getActivityBanners,
    checkActivityAage,
    checkField
}
